import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from "@mui/material";
/** Used for full page errors */
const CError = ({ header, error }) => {
    return (_jsx("div", { style: { width: "100%" }, children: _jsxs(Alert, { severity: "error", children: [_jsx("h2", { children: header || "Error" }), _jsx("div", { children: error })] }) }));
};
export { CError };
